import styles from "./style.module.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// import dataContext from "../../../../context/dataContext";
import mainContext from "../../../context/mainContext";
import Clock from "../../../components/Common/Clock";
import soundWave from "../../../assets/images/icons/soundWave.png";
import { Exercise } from "../../TrainFocus";
import audioPlayer from "../../../components/api/audioPlayerWrapper";

import { PitchShifter } from '../../../dist/soundtouch';
import { FSTraining } from "../../Freestyle";
import userRequests from "../../../components/api/userRequests";
import dataContext from "../../../context/dataContext";
// import { PitchShifter } from './soundtouch.js';
const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
const gainNode = audioCtx.createGain();
let shifter;
let timeCounterInSeconds = 0;
const sundtouchIsOn = false;


const loadSource = function (url, tempo) {
  return new Promise((resolve, reject) => {

    if (shifter) {
      shifter.off();
    }
    fetch(url)
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        console.log('have array buffer');
        audioCtx.decodeAudioData(buffer, (audioBuffer) => {
          console.log('decoded the buffer');
          shifter = new PitchShifter(audioCtx, audioBuffer, 16384);
          shifter.tempo = tempo;
          shifter.pitch = "1.0";
          shifter.on('play', (detail) => {
            console.log("🚀 ~ shifter.on ~ detail:", detail)
            console.log(`timeplayed: ${detail.timePlayed}`);
            console.log("🚀 ~ shifter.on ~ detail.formattedTimePlayed:", detail.formattedTimePlayed)
            console.log("🚀 ~ shifter.on ~ detail.percentagePlayed:", detail.percentagePlayed)
          });
          console.log("🚀 ~ audioCtx.decodeAudioData ~ shifter.formattedDuration:", shifter.formattedDuration);
          resolve(shifter.formattedDuration)
          // playBtn.removeAttribute('disabled');
        });
      }).catch((err) => {
        console.log("🚀 ~ .then ~ err:", err)
        reject(err);
      });
  });
};
let is_playing = false;

const playAUD = function () {
  console.log(shifter)
  shifter.connect(gainNode);
  gainNode.connect(audioCtx.destination);
  audioCtx.resume().then(() => {
    is_playing = true;
    // this.setAttribute('disabled', 'disabled');
  });
};

const pauseAUD = function (playing = false) {
  shifter.disconnect();
  is_playing = playing;
};
const increaseRateAUD = function (increase) {
  console.log("🚀 ~ increaseRateAUD ~ increase:", increase)
  shifter.tempo = increase;
}





function ExerciseClock() {
  // const user = useContext(dataContext);
  const [loadSoundtouchAudioFile, setLoadSoundtouchAudioFile] = useState(false);
  const [isiPhone, setisiPhone] = useState(window.buildType == "iPhone");
  const { header, TR_duration, loader: { setLoaderFetch } } = useContext(mainContext);
  const { userDetails, setUserDetails } = useContext(dataContext);
  const { state } = useLocation();
  const [playing, setPlaying] = useState(false);
  const [musicIsLoad, setMusicIsLoad] = useState(false);
  var LPM_Value = state.New_LPM ? state.New_LPM : Math.round(state.rateData.LPM);
  const LPM_fromPushup = state.LPM_Pushup;
  const newLPM_fromQuestion = state.New_LPM;
  var round = state.roundExercise ? state.roundExercise : 0;
  var clickedButton = state.ClickedButton ? state.ClickedButton : [];
  if (round > 0) {
    clickedButton = state.ClickedButton;
    LPM_Value = newLPM_fromQuestion;
  } else {
    round = 0;
  }
  const [lpm, setLpm] = useState(LPM_Value);
  const audioRef = useRef(null);

  let fileName = pickFile(lpm);


  function submitFunc(state) {
    handleStop();
    state.New_LPM = state.chosenLpm
    let ans = { pushUp: [] }
    state.questions.map(value => ans.pushUp.push(value.answer));
    let res = {
      bookName: state.bookName,
      genre: state.genre || "Genre",
      answers: ans,
      value: state.chosenLpm,
    };
    setLoaderFetch(true);
    userRequests.addNewTr(res, userDetails)
      .then((response) => { setUserDetails(response); console.log("details after pushup", response) })
      .catch((e) => console.log("eror tr", e))
      .finally(() => {
        setLoaderFetch(false);
        navigate("/train-reading/result", { state: { ...state, ...objProps } })
      })

  }

  useEffect(() => {
    header.setPageName("FINE-TUNING");
    // document.addEventListener("pause", onGoBackground);
    // document.addEventListener("visibilitychange", onGoBackground);
    return () => {
      header.setPageName("")
      // document.removeEventListener("pause", onGoBackground);
      // document.removeEventListener("visibilitychange", onGoBackground);
      if (musicIsLoad) {
        handleStop()
      }
    };
  }, [])


  function pickFile(lpm) {
    return lpm < 20 ? 10 : lpm < 60 ? 30 : 80;
  }


  function onPlay() {
    if (!musicIsLoad) {
      handlePlay()
    } else {
      handleResume()
    }
  }

  function onPause() {
    handlePause()
  }

  const onGoBackground = () => {
    if (document.visibilityState === 'hidden') {
      console.log("Browser tab is now in the background");
      handlePause()
    } else if (document.visibilityState === 'visible') {
      console.log("Browser tab is now in the foreground");
    }

  }
  const handlePlay = () => {
    // setLoading(true);

    if (window.cordovaOn) {
      audioPlayer.play(`wush_${fileName}_6min`).then(log => {
        console.log(log)
        setMusicIsLoad(true);
        setPlaying(true);
        let currentSpeed = LPM_Value / fileName;
        console.log("🚀 ~ audioPlayer.play ~ currentSpeed:", currentSpeed)
        handleSetSpeed(currentSpeed)
      }).catch(err => console.error(err)).finally(() => {
        // setLoading(false);

      });
    } else {
      if (isiPhone) {
        if (!loadSoundtouchAudioFile) {
          let currentSpeed = LPM_Value / fileName;
          loadSource(`../../../../audio/wush_${fileName}_6min.mp3`, currentSpeed).then(() => {
            playAUD();
            setLoadSoundtouchAudioFile(true);
            setMusicIsLoad(true);
            setPlaying(true);
          }).catch(err => console.error(err)).finally(() => {
            // setLoading(false);
          });
        } else {
          playAUD();
          setPlaying(true);
        }
      } else {
        const audioElement = audioRef.current;
        if (audioElement) {
          audioElement.play();
          let currentSpeed = LPM_Value / fileName;
          audioElement.playbackRate = currentSpeed;
          setPlaying(true);
        }
      }
    }
  };


  const handlePause = () => {
    if (window.cordovaOn) {
      // Cordova-based logic
      audioPlayer.pause().then(() => {
        setPlaying(false);

      }).catch(err => console.error(err));
    } else {
      // Web-based logic
      if (isiPhone) {
        pauseAUD();
        setPlaying(false);
      } else {

        const audioElement = audioRef.current;
        if (audioElement) {
          audioElement.pause();
          setPlaying(false);
        }
      }
    }
  };


  const handleResume = () => {
    if (window.cordovaOn) {
      // Cordova-based logic
      audioPlayer.resume().then(() => {
        setPlaying(true)
      }).catch(err => console.error(err));
    } else {
      // Web-based logic
      if (isiPhone) {
        playAUD();
        setPlaying(true)
      } else {

        const audioElement = audioRef.current;
        if (audioElement) {
          audioElement.play();
          setPlaying(true)
        }
      }
    }
  };


  const handleStop = () => {
    if (window.cordovaOn) {
      // Cordova-based logic
      audioPlayer.stop().then(() => {
        setPlaying(false);
        setMusicIsLoad(false);
      }).catch(err => console.error(err));
    } else {
      // Web-based logic
      try {
        if (isiPhone) {
          pauseAUD();
          setPlaying(false);
          setMusicIsLoad(false);
        } else {

          const audioElement = audioRef.current;
          if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
            setPlaying(false);
            setMusicIsLoad(false);
          }
        }
      } catch (error) {
        console.log("🚀 ~ handleStop ~ error:", error)

      }
    }
  };

  const handleSetSpeed = (speed) => {//only need for cordova audio plugin so no need to be if else for webApp
    audioPlayer.setSpeed(speed).then(log => {
      console.log("speed is set to:", log)
    }).catch(err => console.error(err));
  };

  const objProps = {
    ...state,
    LPM: LPM_Value, // value form pushup at first after level_round 1 will be the new RATED value
    LPM_Pushup: LPM_fromPushup, // value from pushup
    roundExercise: round,
    ClickedButton: clickedButton,
    fromPath: "train-reading/exercise-clock",
    formInfo: state.formInfo,
  };

  const route = "/train-reading/rate";
  const navigate = useNavigate();

  function onComplete() {
    handleStop()
    setTimeout(() => navigate(route, { state: { ...objProps } }), 300);
  }

  const freeStyleFuncs = {
    onPlay: onPlay, //will turn on the music + remove button and add footer
    onPause: onPause, //will pause the music + remove footer and add button
    // rapid: rapid, // what to send when freeStyle false??
    onComplete: onComplete,
  };



  return (
    // <div className={styles.exerClockPage}>
    //   {(!window.cordovaOn && !isiPhone) && (
    //     <audio ref={audioRef} src={`/audio/wush_${fileName}_6min.mp3`} preload="auto" />
    //   )}
    //   <Clock
    //     playStateFromAbove={playing}
    //     freeStyle={false}
    //     time={TR_duration}
    //     funcs={freeStyleFuncs}
    //     initRapidValue={lpm}
    //   ></Clock>
    //   <div className={styles.squareButton2}>
    //     <div className={styles.rapid}>{LPM_Value}</div>LPM
    //   </div>
    //   <img className={styles.soundWave} src={soundWave} alt="soundWave.png" />
    //   {/* {playing ? */}
    //   {/* <SoundFooter song = {file}></SoundFooter> : <SubmitBtn type={"link"} name={"Done"} path = {"/teamH/graphDashboard"}></SubmitBtn>} */}
    //   {/* <SoundFooter song={file}></SoundFooter> */}
    // </div>
    <FSTraining submitFunc={submitFunc} />
  );
}

export default ExerciseClock;
